const fr = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Se connecter',
  'nav.signOut': 'Se déconnecter',
  'nav.signingIn': 'Connexion…',
  'nav.loading': 'Chargement…',
  'nav.backToDashboard': 'Retour au tableau de bord',
  'nav.back': 'Retour',
  'nav.language': 'Langue',

  'credits.label': 'Crédits : {count}',
  'credits.loading': 'Crédits : —',
  'credits.buyMore': 'Acheter des crédits',
  'credits.tooltipBuy': 'Cliquez pour acheter des crédits',
  'credits.tooltipLoading': 'Chargement de votre solde de crédits',

  'auth.title': 'Connectez-vous pour continuer',
  'auth.subtitle': 'Connectez-vous avec Google pour recevoir vos crédits offerts et suivre votre utilisation',
  'auth.google': 'Continuer avec Google',
  'auth.signOutFailed': 'Impossible de vous déconnecter. Réessayez.',
  'auth.signInFailed': 'Impossible de vous connecter. Réessayez.',

  'landing.headline': 'Créez la photo que vous n’avez pas prise.',
  'landing.sub': 'Connectez-vous pour commencer. Les trois premiers crédits sont offerts.',
  'landing.note': 'Un crédit par image, débité seulement quand l’image arrive.',

  'dash.eyebrow': 'Outils',
  'dash.headline': 'Créez la photo que vous n’avez pas prise.',
  'dash.sub': 'Choisissez un outil. Chacun coûte un crédit, et seulement s’il réussit.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Carte → vue',
  'tool.arrow.desc': 'Placez une flèche n’importe où sur la carte et découvrez la vue depuis ce point.',
  'tool.person.name': 'Suppression de personnes',
  'tool.person.transform': 'Foule → vide',
  'tool.person.desc': 'Retirez les inconnus de la photo et gardez le lieu où vous êtes allé.',
  'tool.clothing.name': 'Essayage virtuel',
  'tool.clothing.transform': 'Vêtement → vous',
  'tool.clothing.desc': 'Essayez un vêtement avant de décider de l’acheter.',

  'upload.title': 'Importez votre image',
  'upload.hint': 'Cliquez pour choisir une image ou glissez-la ici',
  'upload.formats': 'Formats : JPG, PNG, GIF • Taille max : 10 Mo',
  'upload.person': 'Importer la photo de la personne',
  'upload.clothing': 'Importer la photo du vêtement',
  'upload.selectImage': 'Cliquez pour choisir une image',
  'upload.formatsShort': 'JPG, PNG — 10 Mo max',
  'upload.tooLarge': 'Cette image dépasse 10 Mo. Choisissez-en une plus petite.',
  'upload.notImage': 'Ce fichier n’est pas une image. Choisissez un JPG ou un PNG.',

  'action.generate': 'Générer',
  'action.generating': 'Génération…',
  'action.download': 'Télécharger',
  'action.share': 'Partager',
  'action.delete': 'Supprimer',
  'action.cancel': 'Annuler',
  'action.tryAgain': 'Réessayer',
  'action.uploadCustom': 'Importer la vôtre',
  'action.browseLibrary': 'Parcourir la bibliothèque',

  'history.show': 'Voir les images récentes ({count})',
  'history.hide': 'Masquer les images récentes',
  'history.empty': 'Rien pour l’instant. Vos images apparaîtront ici.',

  'gen.working': 'Création de votre image…',
  'gen.takesTime': 'Cela prend en général moins d’une minute.',
  'gen.noCredits': 'Vous n’avez plus de crédits. Achetez-en pour continuer.',
  'gen.failed': 'Cela n’a pas fonctionné. Votre crédit n’a pas été débité.',
  'gen.blocked': 'Le filtre de sécurité a refusé cette photo. Essayez-en une autre : votre crédit n’a pas été débité.',

  'pay.title': 'Acheter des crédits',
  'pay.subtitle': 'Les crédits n’expirent pas.',
  'pay.creditsLabel': '{count} crédits',
  'pay.saved': '{amount} économisés',
  'pay.pay': 'Payer {amount}',
  'pay.processing': 'Traitement…',
  'pay.success': 'Paiement effectué. Vos crédits ont été ajoutés.',
  'pay.failed': 'Le paiement a échoué. Vous n’avez pas été débité.',
  'pay.completeTitle': 'Paiement effectué',
  'pay.completeBody': 'Vos crédits ont été ajoutés à votre compte.',

  'error.title': 'Une erreur est survenue',
  'error.body': 'La page a rencontré une erreur inattendue. Recharger suffit en général.',
  'error.reload': 'Recharger la page',
  'notFound.title': 'Page introuvable',
  'notFound.body': 'Cette adresse ne correspond à rien dans le studio.',
  'notFound.home': 'Aller au tableau de bord',

  'footer.privacy': 'Politique de confidentialité',
};

export default fr;
